import { _ } from '@ngx-translate/core';

/**
 * Units.
 */
export enum Units {

  /**
   * Feet.
   */
  Feet,

  /**
   * Meters.
   */
  Meters,

  /**
   * Foot-lambert.
   */
  FL,

  /**
   * Lumens.
   */
  Lumens,

  /**
   * Nits.
   */
  Nits,
}

/**
 * Helper methods for Enum.
 */
export namespace Units {
  const TO_TITLE_MAP: Record<Units, string> = {
    [Units.Feet]: _('units.ft'),
    [Units.Meters]: _('units.m'),
    [Units.FL]: _('units.fL'),
    [Units.Nits]: _('units.nits'),
    [Units.Lumens]: _('units.lm'),
  };

  /**
   * Convert a certain Enum value to readable title.
   * @param value Value of Enum.
   */
  export function toReadable(value: Units): string {
    return TO_TITLE_MAP[value];
  }

  /** Get list of length units enum items. */
  export function toLengthUnitsArray(): Units[] {
    return [
      Units.Feet,
      Units.Meters,
    ];
  }

  /** Get list of brightness units enum items. */
  export function toBrightnessUnitsArray(): Units[] {
    return [
      Units.FL,
      Units.Nits,
    ];
  }

  /**
   * Track by function.
   */
  export function trackBy(_index: number, item: Units): Units {
    return item;
  }

  /**
   * Comparator for sort function.
   */
  export function sortComparator(first: Units, second: Units): number {
    const allItems = Units.toLengthUnitsArray();
    return allItems.indexOf(first) - allItems.indexOf(second);
  }
}
